import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { getAvatarUrl } from './utils/Common';

const Profile = () => {
  const { user, refreshUser } = useAuth();

  useEffect(() => {
    // Refresh user data when profile page loads to get latest info
    refreshUser();
  }, [refreshUser]);

  // if (!user) {
  //     return (<div>"loading"</div>)
  // }
  return (
    <div className="page-container">
      <div className="page-header">
        <h2>Mój Profil</h2>
        <p>Informacje o Twoim koncie.</p>
      </div>
      
      <div className="page-content">
        <div className="profile-card">
          <div className="profile-avatar-large">
            {getAvatarUrl(user?.avatar) ? (
              <img src={getAvatarUrl(user?.avatar)} alt="Profile" className="profile-avatar-image" />
            ) : (
              <span className="profile-avatar-initial">
                {user?.full_name?.charAt(0).toUpperCase() || 'U'}
              </span>
            )}
          </div>
          <div className="profile-details">
            <h3>{user?.full_name}</h3>
            <p className="profile-email">{user?.email}</p>
            <div className="profile-info-grid">
              <div className="profile-info-item">
                <label>Jednostka org.</label>
                <span>{user?.department || 'Nie przypisano'}</span>
              </div>
              <div className="profile-info-item">
                <label>Stanowisko</label>
                <span>{user?.position_name || 'Nie przypisano'}</span>
              </div>
              <div className="profile-info-item">
                <label>Telefon</label>
                <span>{user?.phone_number || 'Nie podano'}</span>
              </div>
              <div className="profile-info-item">
                <label>Status</label>
                <span className={`status-badge ${user?.is_active ? 'active' : 'inactive'}`}>
                  {user?.is_active ? 'Aktywny' : 'Nieaktywny'}
                </span>
              </div>
              <div className="profile-info-item">
                <label>Członek od</label>
                <span>{new Date(user?.created_at).toLocaleDateString()}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
